import _ from 'lodash';
import Numeral from 'numeral';
import {
  DUNGEON_SCORE_ALT_FACTOR,
  DUNGEON_SCORE_MAIN_FACTOR,
  mythicScoreUseAlternateDungeon
} from '../../../../shared/enums';
import { SimpleTooltip } from '../../../../../../shared/frontend/components/presentational/tooltip';
import { TScoringSystem } from '../../../../../../shared/gameConfig/mythicPlus';

export function MythicPlusLevel(props: any) {
  return (
    <span>
      <span className={props.sizeClass ? props.sizeClass : 'slds-text-heading--small'}>
        {props.skipPlus ? '' : '+'}
        <span className={props.underlineLevel ? 'text-underline' : ''}>{props.level}</span>
      </span>
      <span style={{ fontSize: 6, position: 'relative', left: 4, top: '-0.3rem' }}>
        {_.range(props.numChests).map((n) => (
          <i key={n} className="rio-spaced-element--small fa fa-star text-gold" />
        ))}
        {props.padChests
          ? _.range(3 - props.numChests).map((n) => (
              <i key={n} className="rio-spaced-element--small fa fa-star text-gold" style={{ visibility: 'hidden' }} />
            ))
          : null}
      </span>
    </span>
  );
}

export function MythicPlusLevelTooltip(props: {
  run: any;
  isAlternate: boolean;
  scoringSystem: TScoringSystem;
  isBestRun: boolean;
}) {
  const { run, isAlternate, scoringSystem, isBestRun } = props;
  const modifiers = run.weekly_modifiers?.modifiers || run.weekly_modifiers || [];

  const mythicLevelContent = (
    <div className={isBestRun ? 'text-bold' : ''}>
      <MythicPlusLevel underlineLevel={isBestRun} level={run.mythic_level} numChests={run.num_chests} />
    </div>
  );

  if (!mythicScoreUseAlternateDungeon(scoringSystem)) {
    return (
      <SimpleTooltip
        placement="bottom"
        tooltip={
          <span>
            <span className="slds-text-body--x-small slds-text-align--left text-white">
              {run.num_chests !== 0 ? <span>Keystone Upgraded +{run.num_chests}</span> : null}
              {run.num_chests === 0 ? <span style={{ color: '#aaa' }}>Keystone Depleted</span> : null}
            </span>
          </span>
        }
      >
        {mythicLevelContent}
      </SimpleTooltip>
    );
  }

  const rating = run.score * (isAlternate ? DUNGEON_SCORE_ALT_FACTOR : DUNGEON_SCORE_MAIN_FACTOR);

  return (
    <SimpleTooltip
      placement="bottom"
      tooltip={
        <span className="slds-text-align--center text-white ">
          <div className="text-underline">Best {modifiers[0]?.name}</div>
          <div className="slds-text-body--small slds-m-top--xx-small">
            Base Score: <b>{Numeral(run.score).format('0,0.0')}</b>
            <br />
            Rating: <b>{Numeral(rating).format('0,0.0')}</b>
          </div>
        </span>
      }
    >
      {mythicLevelContent}
    </SimpleTooltip>
  );
}
